<script setup>
import { computed } from 'vue'
import { getLifecycleStatusMeta } from '../utils/adminUi.js'

const props = defineProps({
  entity: {
    type: [Object, Boolean],
    default: null,
  },
  statusMeta: {
    type: Object,
    default: null,
  },
})

const meta = computed(() => {
  if (props.statusMeta?.label && props.statusMeta?.className) {
    return props.statusMeta
  }
  return getLifecycleStatusMeta(props.entity)
})
</script>

<template>
  <span :class="['lifecycle-badge', `lifecycle-badge-${meta.className}`]">
    {{ meta.label }}
  </span>
</template>

<style scoped>
.lifecycle-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  text-transform: capitalize;
  font-weight: 600;
}

.lifecycle-badge-active {
  background: #dcfce7;
  color: #166534;
}

.lifecycle-badge-deleted {
  background: #fee2e2;
  color: #991b1b;
}

.lifecycle-badge-warning {
  background: #fffbeb;
  color: #92400e;
}

.lifecycle-badge-neutral {
  background: #e5e7eb;
  color: #374151;
}
</style>
